// * Start hours offered in self-scheduling, shared by the hour grid (SelectTime) and the calendar
// * (CustomCalendar). `showByDefault: false` hours only show up when the previous block is taken
// * (see the `previousHourValidation` step in both components).
const availableHours = [
  { hour: '08:00', available: true, validatePrev: false, showByDefault: true },
  { hour: '08:30', available: true, validatePrev: false, showByDefault: true },
  { hour: '09:00', available: true, validatePrev: false, showByDefault: true },
  { hour: '09:30', available: true, validatePrev: false, showByDefault: true },
  { hour: '10:00', available: true, validatePrev: false, showByDefault: true },
  { hour: '10:30', available: true, validatePrev: false, showByDefault: true },
  { hour: '11:00', available: true, validatePrev: false, showByDefault: true },
  { hour: '11:30', available: true, validatePrev: false, showByDefault: true },
  { hour: '12:00', available: true, validatePrev: false, showByDefault: true },
  { hour: '12:30', available: true, validatePrev: false, showByDefault: true },
  { hour: '14:30', available: true, validatePrev: false, showByDefault: true },
  { hour: '15:00', available: true, validatePrev: false, showByDefault: true },
  { hour: '15:30', available: true, validatePrev: false, showByDefault: true },
  { hour: '16:00', available: true, validatePrev: false, showByDefault: true },
  { hour: '16:30', available: true, validatePrev: false, showByDefault: true },
  { hour: '17:00', available: true, validatePrev: false, showByDefault: false },
];

export default availableHours;
